import React, { useState, useContext, useEffect, useRef } from 'react';
import { Text, View } from 'react-native';
import { useInView } from 'react-intersection-observer';
import { useSpring, animated } from 'react-spring';

import { hpContext } from '../../hp/HPContext';


function FadeinWrap(props) {

  const isWide = useContext(hpContext).isWide;
  const loop = props.loop? !props.loop : true;

  const { ref, inView } = useInView({
    // オプション
    rootMargin: '-100px', // ref要素が現れてから50px過ぎたら
    triggerOnce: loop, // 最初の一度だけ実行
  });


  const animate = useSpring({
    opacity: inView ? 1 : 0,
  });



  return (
    <View ref={ref}>
      <animated.div style={animate}>
        {props.children}
      </animated.div>
    </View>
  );
}


export default FadeinWrap;